export const storeConfiguration = new Map([
  [
    'AT',
    {
      available: 'Trendhim ist in Deinem Land verfügbar',
      goTo: 'Gehe zu %s',
      locale: 'de-AT',
      stayAt: 'Bleibe bei %s',
      url: 'https://www.trendhim.at',
    },
  ],
  [
    'AU',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-AU',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.com.au',
    },
  ],
  [
    'BE',
    {
      available: 'Trendhim is beschikbaar in jouw land',
      stayAt: 'Blijf op %s',
      locale: 'nl-BE',
      goTo: 'Ga naar %s',
      url: 'https://www.trendhim.be',
    },
  ],
  [
    'BG',
    {
      available: 'Trendhim е на разположение във Вашата страна',
      stayAt: 'Останете на %s',
      locale: 'bg-BG',
      goTo: 'Отидете на %s',
      url: 'https://www.trendhim.bg',
    },
  ],
  [
    'CA',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-CA',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.ca',
    },
  ],
  [
    'CH',
    {
      available: 'Trendhim ist in Deinem Land verfügbar',
      stayAt: 'Bleibe bei %s',
      locale: 'de-CH',
      goTo: 'Gehe zu %s',
      url: 'https://www.trendhim.ch',
    },
  ],
  [
    'CZ',
    {
      available: 'Trendhim rozšířil své pole působnosti i do Vaší země',
      stayAt: 'Zůstat na %s',
      locale: 'cs-CZ',
      goTo: 'Přejít na %s',
      url: 'https://www.trendhim.cz',
    },
  ],
  [
    'DE',
    {
      available: 'Trendhim ist in Deinem Land verfügbar',
      stayAt: 'Bleibe bei %s',
      locale: 'de-DE',
      goTo: 'Gehe zu %s',
      url: 'https://www.trendhim.de',
    },
  ],
  [
    'DK',
    {
      available: 'Trendhim er tilgængelig i dit land',
      stayAt: 'Bliv ved %s',
      locale: 'da-DK',
      goTo: 'Gå til %s',
      url: 'https://www.trendhim.dk',
    },
  ],
  [
    'ES',
    {
      available: 'Trendhim está disponible en tu país',
      stayAt: 'Permanece en %s',
      locale: 'es-ES',
      goTo: 'Dirígete a %s',
      url: 'https://237.p.syniva.es',
    },
  ],
  [
    'FI',
    {
      available: 'Trendhim toimii maassasi',
      stayAt: 'Pysy %s',
      locale: 'fi-FI',
      goTo: 'Mene %s',
      url: 'https://www.trendhim.fi',
    },
  ],
  [
    'FR',
    {
      available: 'Trendhim est disponible dans votre pays',
      stayAt: 'Rester sur %s',
      locale: 'fr-FR',
      goTo: 'Vers %s',
      url: 'https://www.trendhim.fr',
    },
  ],
  [
    'GB',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-GB',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.co.uk',
    },
  ],
  [
    'GR',
    {
      available: 'Η Trendhim είναι διαθέσιμη στην χώρα σου',
      stayAt: 'Μείνε σε %s',
      locale: 'el-GR',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.gr',
    },
  ],
  [
    'HU',
    {
      available: 'Az országodból vásárolhatsz a Trendhimnél',
      stayAt: 'Maradok itt: %s',
      locale: 'hu-HU',
      goTo: 'Tovább: %s',
      url: 'https://www.trendhim.hu',
    },
  ],
  [
    'IE',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-IE',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.ie',
    },
  ],
  [
    'IT',
    {
      available: 'Trendhim è disponibile nel tuo paese',
      stayAt: 'Resta su %s',
      locale: 'it-IT',
      goTo: 'Vai su %s',
      url: 'https://www.trendhim.it',
    },
  ],
  [
    'NL',
    {
      available: 'Trendhim is beschikbaar in jouw land',
      stayAt: 'Blijf op %s',
      locale: 'nl-NL',
      goTo: 'Ga naar %s',
      url: 'https://www.trendhim.nl',
    },
  ],
  [
    'NO',
    {
      available: 'Trendhim er tiligjengelig i ditt land',
      stayAt: 'Bli hos %s',
      locale: 'nb-NO',
      goTo: 'Gå til %s',
      url: 'https://www.trendhim.no',
    },
  ],
  [
    'NZ',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-NZ',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.co.nz',
    },
  ],
  [
    'PL',
    {
      available: 'Trendhim działa na terenie Twojego kraju',
      stayAt: 'Pozostań na %s',
      locale: 'pl-PL',
      goTo: 'Przejdź do %s',
      url: 'https://www.trendhim.pl',
    },
  ],
  [
    'PT',
    {
      available: 'A Trendhim está disponível no seu país',
      stayAt: 'Ficar em %s',
      locale: 'pt-PT',
      goTo: 'Ir para %s',
      url: 'https://www.trendhim.pt',
    },
  ],
  [
    'RO',
    {
      available: 'Trendhim este disponibil în țara ta',
      stayAt: 'Rămâi la %s',
      locale: 'ro-RO',
      goTo: 'Către %s',
      url: 'https://www.trendhim.ro',
    },
  ],
  [
    'SE',
    {
      available: 'Trendhim finns tillgängligt i ditt land',
      stayAt: 'Stanna på %s',
      locale: 'sv-SE',
      goTo: 'Gå till %s',
      url: 'https://www.trendhim.se',
    },
  ],
  [
    'SG',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-SG',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.sg',
    },
  ],
  [
    'SK',
    {
      available: 'Trendhim rozšíril svoje pole pôsobnosti aj do Vašej krajiny',
      stayAt: 'Zostať na %s',
      locale: 'sk-SK',
      goTo: 'Prejsť na %s',
      url: 'https://www.trendhim.sk',
    },
  ],
  [
    'US',
    {
      available: 'Trendhim is available in your country',
      stayAt: 'Stay at %s',
      locale: 'en-US',
      goTo: 'Go to %s',
      url: 'https://www.trendhim.com',
    },
  ],
])
